import type { UIMatch } from 'react-router'
import { useMatches } from 'react-router'

import type { RouteHandle } from '~/router/types'
import { ShellTestTable } from '~/test-components/Table'

/** Placeholder page for every node in the Home app tree. The heading is the matched route's title
 * (the node name, set by `buildNavRoutes`); the title attribute + breadcrumb are owned by the Shell,
 * and the outer page padding by the Shell canvas. */
export const TestPage = () => {
  const title =
    (useMatches().at(-1) as UIMatch<unknown, RouteHandle | undefined> | undefined)?.handle?.title ??
    ''

  return (
    <main>
      <h1>{title}</h1>
      <ShellTestTable />
    </main>
  )
}
